export default __webpack_public_path__ + "static/media/bg.653586bd.png";